import { defineAsyncComponent } from 'vue'
export default {
  checkout: defineAsyncComponent(() => import("/etc/buildAgent/work/74baefd00478bfe1/packages/web-app/layouts/checkout.vue").then(m => m.default || m)),
  default: defineAsyncComponent(() => import("/etc/buildAgent/work/74baefd00478bfe1/packages/web-app/layouts/default.vue").then(m => m.default || m))
}